import { useMutation, useQueryClient } from '@tanstack/react-query';
import { planInquiryApi } from '@src/apis/admin';
import type { PlanInquiryUpdateRequestModel, PlanInquiryResponseModel } from '@uniquegood/realworld-admin-interface';
import type { EnterpriseInquiryListResponse } from '@src/models/enterprise-inquiry';

export interface UseUpdatePlanInquiryParams {
  inquiryId: string;
  data: PlanInquiryUpdateRequestModel;
}

/**
 * 엔터프라이즈 문의 수정 훅
 */
export const useUpdatePlanInquiry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updatePlanInquiry'],
    mutationFn: async ({ inquiryId, data }: UseUpdatePlanInquiryParams) => {
      const response = await planInquiryApi.updatePlanInquiry(inquiryId, undefined, data);
      return {
        inquiryId,
        updatedInquiry: response.data.data,
      };
    },
    onSuccess: ({ inquiryId, updatedInquiry }) => {
      // 리스트를 다시 호출하지 않고, 수정된 객체로 직접 업데이트
      queryClient.setQueriesData<EnterpriseInquiryListResponse>(
        { queryKey: ['plan-inquiries'] },
        (oldData) => {
          if (!oldData || !updatedInquiry) return oldData;

          return {
            ...oldData,
            inquiries: oldData.inquiries.map((inquiry) =>
              inquiry.id === inquiryId ? updatedInquiry : inquiry
            ),
          };
        }
      );
    },
  });
};

